const menu = ($el) => {
    if (typeof $el !== 'undefined' && $el != null) {
        const $body = document.querySelector('.js-body')
        const $menuToggleBtn = $el.querySelector('.js-menu-toggle')
        const menuActiveClass = 'menu-is-active'
        const isActiveClass = 'is-active'
        const stopScrollingClass = 'stop-scrolling'
        let menuIsOpen = false

        /**
         * Set up mq reset
         */
        const mq = '(max-width: 1130px)'
        const mql = window.matchMedia(mq)

        const $dropdownMenus = [...$el.querySelectorAll('.js-dropdown-menu')]
        const $carparkLocationMenus = [...$el.querySelectorAll('.js-carpark-location')]
        const $dropdownToggles = [...$el.querySelectorAll('.js-dropdown-toggle')]
        const $locationToggles = [...$el.querySelectorAll('.js-location-toggle')]

        /**
         * Open menu
         * @param {} $el 
         * @param {*} $body 
         */
        const openMobileMenu = ($el, $body) => {
            $body.classList.add(stopScrollingClass)
            $el.classList.add(menuActiveClass)
        }

        /**
         * Close menu
         * @param {*} $el 
         * @param {*} $body 
         * @param {*} $dropdownMenus 
         * @param {*} $carparkLocationMenus 
         */
        const closeMobileMenu = ($el, $body, $dropdownMenus, $carparkLocationMenus) => {
            $el.classList.remove(menuActiveClass)
            $body.classList.remove(stopScrollingClass)

            if ($dropdownMenus || $carparkLocationMenus ) {
                $dropdownMenus.forEach($menu => {
                    $menu.classList.add('hidden')
                })

                $carparkLocationMenus.forEach($menu => {
                    $menu.classList.add('hidden')
                })
            }

            if ($dropdownToggles) {
                $dropdownToggles.forEach($toggle => {
                    $toggle.classList.remove(isActiveClass)
                    $toggle.setAttribute('aria-expanded', false)
                })
            }

            if ($locationToggles) {
                $locationToggles.forEach($toggle => {
                    $toggle.classList.remove(isActiveClass)
                    $toggle.setAttribute('aria-expanded', false)
                })
            }
        }

        /**
         * Bind events
         */
        if ($menuToggleBtn) {
            $menuToggleBtn.addEventListener('click', () => {
                menuIsOpen = !menuIsOpen
                if (menuIsOpen) {
                    openMobileMenu($el, $body)
                    $menuToggleBtn.setAttribute('aria-expanded', true)
                } else {
                    closeMobileMenu($el, $body, $dropdownMenus, $carparkLocationMenus)
                    $menuToggleBtn.setAttribute('aria-expanded', false)
                }
            })

            /**
             * Reset mobile menu on mql
             */
            mql.addEventListener('change', event => {
                if (!event.matches) {
                    closeMobileMenu($el, $body, $dropdownMenus, $carparkLocationMenus)
                    $menuToggleBtn.setAttribute('aria-expanded', false)
                    menuIsOpen = false
                } 
            })
        }
    }
}

export default menu